import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../service/authService';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	constructor(private authService: AuthService,
		private router: Router) {
	}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(catchError(err => {
			console.debug('***');
			console.debug(err);
			if (err.status === 401 || err.status === 403) {

				// auto logout if 401 response returned from api
				this.authService.logout();

				// DEBUG
				// console.log(this.router.url);
				// console.log(this.router.url.indexOf('/login'));

				if (!(this.router.url.indexOf('/login') === 0)) {
					// location.reload();
					this.router.navigate(['/login']);
				}
			}

			// const error = err.error.message || err.statusText;
			return throwError(err);
		}));
	}
}
